import styles from "./style.module.scss";
import clsx from "clsx";
import { FormData } from "src/types/form";
import { prefectures } from "src/validate";

export const FormSection = ({
  formData,
  errors,
  setFormData,
  onSubmit,
}: {
  formData: FormData;
  errors: string[];
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  onSubmit: () => void;
}) => {
  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value as FormData["options"][number];
    const checked = e.target.checked;

    setFormData((prev): FormData => {
      const updated = checked
        ? [...prev.options, value]
        : prev.options.filter((v) => v !== value);

      return {
        ...prev,
        options: updated,
      };
    });
  };

  return (
    <section className={styles.container}>
      <div className={styles.innerBox}>
        <div className={styles.calendarBox}>
          <iframe
            title="Google Calendar"
            src="https://calendar.google.com/calendar/embed?src=ffc7a11636547ebf070b7379ca80343fc9a35eb21e72506847b46dba92ecb238%40group.calendar.google.com&ctz=Asia%2FTokyo&showTitle=0&showCalendars=0&showPrint=0&showTabs=0&mode=MONTH"
            style={{ border: 0 }}
          />
        </div>

        <div className={clsx(styles.inputBox, styles.mt)}>
          <label>日程</label>
          <div className={styles.flexBox}>
            <div className={styles.flexInnerBox}>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={formData.startDate || ""}
                onChange={handleChange}
              />
            </div>
            <p className={styles.range}>~</p>
            <div className={styles.flexInnerBox}>
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={formData.endDate || ""}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label>利用人数</label>
          <div className={styles.flexBox}>
            <div className={styles.flexInnerBox}>
              <p>大人人数</p>
              <input
                type="text"
                id="adultCount"
                name="adultCount"
                value={formData.adultCount || ""}
                onChange={handleChange}
              />
              <p>人</p>
            </div>
            <div className={styles.flexInnerBox}>
              <p>子供人数</p>
              <input
                type="text"
                id="childCount"
                name="childCount"
                value={formData.childCount || ""}
                onChange={handleChange}
              />
              <p>人</p>
            </div>
          </div>
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="roomType">部屋タイプ</label>
          <div className={styles.selectWrapper}>
            <select
              id="roomType"
              name="roomType"
              value={formData.roomType}
              onChange={handleChange}
            >
              <option value="">選択してください</option>
              <option value="SANRIKU">SANRIKU</option>
              <option value="JIGNOMAKI">JIGNOMAKI</option>
            </select>
          </div>
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="name">お名前</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="kanaName">ふりがな</label>
          <input
            type="text"
            id="kanaName"
            name="kanaName"
            value={formData.kanaName}
            onChange={handleChange}
          />
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="phone">
            電話番号
            <span style={{ color: "#000", fontWeight: "normal" }}>
              　(ハイフンなし)
            </span>
          </label>
          <input
            type="text"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
          />
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="email">メールアドレス</label>
          <input
            type="text"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="emailConfirm">メールアドレス (再入力)</label>
          <input
            type="text"
            id="emailConfirm"
            name="emailConfirm"
            value={formData.emailConfirm}
            onChange={handleChange}
          />
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <div className={styles.flexBox}>
            <div className={styles.flexInnerBox} style={{ width: "100%" }}>
              <label>
                郵便番号
                <br />
                <span style={{ color: "#000", fontSize: "60%" }}>
                  (ハイフンなし)
                </span>
              </label>
              <input
                type="text"
                id="postalCode"
                name="postalCode"
                value={formData.postalCode || ""}
                onChange={handleChange}
              />
            </div>
            <div className={styles.flexInnerBox} style={{ width: "100%" }}>
              <label>都道府県</label>
              <div className={styles.selectWrapper}>
                <select
                  id="prefecture"
                  name="prefecture"
                  value={formData.prefecture}
                  onChange={handleChange}
                >
                  <option value="">未選択</option>
                  {prefectures.map((prefecture) => (
                    <option key={prefecture} value={prefecture}>
                      {prefecture}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="emailConfirm">市区町村郡／番地</label>
          <input
            type="text"
            id="city"
            name="city"
            value={formData.city}
            onChange={handleChange}
          />
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="emailConfirm">体験希望</label>
          <div style={{ marginLeft: "2%", marginTop: "1%" }}>
            <p className={styles.description}>
              体験したいものがある場合は下記を選択ください。
            </p>
            <div className={styles.checkboxBox}>
              <label>
                <input
                  type="checkbox"
                  name="option"
                  value="YAKISOBA"
                  onChange={handleCheckboxChange}
                />
                <span>買い物から調理まで！元祖石巻焼そばづくり</span>
              </label>
            </div>
            <div className={styles.checkboxBox}>
              <label>
                <input
                  type="checkbox"
                  name="option"
                  value="FISHING"
                  onChange={handleCheckboxChange}
                />
                <span>釣り船に乗って旬の魚をフィッシング釣り体験</span>
              </label>
            </div>
            <div className={styles.checkboxBox}>
              <label>
                <input
                  type="checkbox"
                  name="option"
                  value="DIVING"
                  onChange={handleCheckboxChange}
                />
                <span>ダイビングで四季のある海の中へ</span>
              </label>
            </div>
            <div className={styles.checkboxBox}>
              <label>
                <input
                  type="checkbox"
                  name="option"
                  value="SAUNA"
                  onChange={handleCheckboxChange}
                />
                <span>自然の循環を感じ、森に溶け込む極上サウナ</span>
              </label>
            </div>
            <p className={styles.description} style={{ margin: "2% 0" }}>
              ※体験の詳細は
              <a
                href="/activity"
                target="_blank"
                rel="noreferrer"
                className={styles.link}
              >
                こちら
              </a>
              をご覧ください。
            </p>
          </div>
        </div>
        <div className={clsx(styles.inputBox, styles.mt)}>
          <label htmlFor="emailConfirm">その他の要望（任意）</label>
          <textarea
            id="body"
            name="body"
            value={formData.body}
            onChange={handleChange}
            className={styles.texeArea}
          />
        </div>

        {errors.length > 0 && (
          <div style={{ marginTop: "2%" }}>
            {errors.map((error, i) => (
              <p className={styles.error} key={i}>
                {error}
              </p>
            ))}
          </div>
        )}

        <div className={styles.submitBox}>
          <button onClick={onSubmit}>確認画面へ</button>
        </div>
      </div>
    </section>
  );
};
